import { useQuery } from '@tanstack/react-query'

import useEmptyStateStore from '../../../hooks/isEmptyState/useEmptyStateStore'
import { request } from '../../../lib/axios'
import { QueryConfig, ExtractFnReturnType, queryClient } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'

import { PlatformStatus } from '../models'

export type PlatformsResponse = {
  platforms: PlatformStatus[]
}

export const getPlatforms = async (accountId: number): Promise<PlatformsResponse | Error> => {
  return await request<PlatformsResponse>({
    url: `/accounts/${accountId}/platforms`,
    method: 'GET',
  })
}

type QueryFnType = typeof getPlatforms

export const useGetPlatforms = ({ config }: { config?: QueryConfig<QueryFnType> } = {}) => {
  const { accountId } = useUserStore()
  const { showPmDashboard } = useEmptyStateStore()

  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['getPlatforms', accountId],
    onSuccess: () => {
      showPmDashboard({ getPlatforms: true })
      void queryClient.invalidateQueries({
        queryKey: ['getPlatformsAudiences'],
        refetchType: 'inactive',
      })
    },
    queryFn: () => {
      showPmDashboard({ getPlatforms: false })
      return getPlatforms(accountId)
    },
    onSettled: () => {
      showPmDashboard({ getPlatforms: true })
    },
    ...config,
  })

  const data = query.data instanceof Error ? undefined : query.data?.platforms

  return { ...query, data }
}
